var View = require('views/view')
var app = require('application')

module.exports = View.extend({
  template: require('views/templates/login'),
  grecaptchaLogin: null,
  grecaptchaRegister: null,
  events () { // On récupère ici les events de view (les event globaux) pis on ajoute les spécifiques a cette vue (SOURCE : http://stackoverflow.com/questions/9403675/backbone-view-inherit-and-extend-events-from-parent)
    return _.extend({}, View.prototype.events, {
      'click #register-form-link': 'showRegister',
      'click #login-form-link': 'showLogin',
      'change .radio-profil': 'changeProfil'
    })
  },
  afterRender (event, res) {
    if (event === 'activate') {
      let activationNok = res && res.errors && res.errors > 0
      let activationOk = res === true
      let error = res && res.error || null

      $('#login-container').empty().html(require('views/templates/login-activate')({ activationOk, activationNok, error }))
    } else {
      app.initDateTimepickers()

      app.validator('login-form', [
        { name: 'username', display: 'Nom d\'utilisateur', rules: 'required' },
        { name: 'password', display: 'Mot de passe', rules: 'required' }
      ], this.login.bind(this))

      app.validator('register-form', [
        { name: 'nom', display: 'Nom', rules: 'required' },
        { name: 'prenom', display: 'Prénom', rules: 'required' },
        { name: 'username', display: 'Nom d\'utilisateur', rules: 'required' },
        { name: 'password', display: 'Mot de passe', rules: 'required|pwdTyp1' },
        { name: 'email', display: 'Adresse email', rules: 'required|valid_email' },
        { name: 'confirm-password', display: 'Confirmation de mot de passe', rules: 'required|matches[password]' }
      ], this.register.bind(this))

      this.grecaptchaLogin = grecaptcha.render('g-recaptcha-login', { sitekey: '6LdHoj0UAAAAAM1Ia_SSPJoLchh9QycXc2yo4lTZ' })
      this.grecaptchaRegister = grecaptcha.render('g-recaptcha-register', { sitekey: '6LdHoj0UAAAAAM1Ia_SSPJoLchh9QycXc2yo4lTZ' })
    }
  },
  showRegister (e) {
    $('#success-box, #error-box').hide()
    $('#register-form').delay(100).fadeIn(100)
    $('#login-form').fadeOut(100)
    $('#login-form-link').removeClass('active')
    $(e.currentTarget).addClass('active')
    e.preventDefault()
  },
  showLogin (e) {
    $('#success-box, #error-box').hide()
    $('#login-form').delay(100).fadeIn(100)
    $('#register-form').fadeOut(100)
    $('#register-form-link').removeClass('active')
    $(e.currentTarget).addClass('active')
    e.preventDefault()
  },
  register (e) {
    if (e) e.preventDefault()
    let data = $('#register-form').serialize()
    app.modalWait()
    app.ajax({
      url: '/login/register',
      type: 'POST',
      data,
      complete: app.onComplete({
        success: (res) => {
          $('#success-box').html(`
            <p>
              <strong>Félicitations !</strong><br>Votre compte a bien été créé.<br>Un email d'activation a été envoyé a l'adresse mail renseignée.
              Vous pourrez vous connecter lorsque vous aurez activé votre compte.
            </p>
          `).fadeIn()
          $('#register-form input').attr('disabled', true)
        },
        complete: () => {
          app.modalWait('hide')
          grecaptcha.reset(this.grecaptchaRegister)
        }
      })
    })
  },
  login (e) {
    if (e) e.preventDefault()
    let data = $('#login-form').serialize()
    app.modalWait()
    app.ajax({
      url: '/login',
      type: 'POST',
      data,
      complete: app.onComplete({
        success: (res) => {
          window.location = '/'
        },
        complete: () => {
          app.modalWait('hide')
          grecaptcha.reset(this.grecaptchaLogin)
        }
      })
    })
  },
  renderActivateScreen () {
    $('#container').html(require('views/templates/login-activate')())
    $('.btn-resend-activation-mail').on('click', this.resendActivationMail.bind(this))
  },
  resendActivationMail (e) {
    let h = $(e.currentTarget).html()
    $(e.currentTarget).html('<i class="fa fa-spinner fa-spin"></i> Chargement...').attr('disabled', true)
    let data = { id: this.session.user.id_user }
    app.ajax({
      url: '/login/resendActivateMail',
      data,
      type: 'POST',
      complete: app.onComplete({
        success: (res) => {
          $(e.currentTarget).attr('disabled', false).html(h)
        }
      })
    })
  },
  changeProfil (e) {
    if ($(e.currentTarget).find('input[name=id_profil]').val() === '2') {
      $('.paypal-infos').fadeIn()
    } else {
      $('.paypal-infos').fadeOut()
    }
  }
})
